import { Heart } from "lucide-react";
import { useWishlist } from "@/contexts/WishlistContext";
import { cn } from "@/lib/utils";

interface WishlistButtonProps {
  productId: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const WishlistButton = ({ productId, size = "md", className }: WishlistButtonProps) => {
  const { isInWishlist, toggleWishlist } = useWishlist();
  const isWishlisted = isInWishlist(productId);

  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
  };

  const iconSizes = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(productId);
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "rounded-full bg-background/80 backdrop-blur-sm flex items-center justify-center transition-all duration-300 hover:scale-110",
        sizeClasses[size],
        isWishlisted 
          ? "text-primary" 
          : "text-muted-foreground hover:text-primary",
        className
      )}
      aria-label={isWishlisted ? "Verwijder uit favorieten" : "Voeg toe aan favorieten"}
    >
      <Heart
        className={cn(
          iconSizes[size],
          isWishlisted && "fill-primary"
        )}
      />
    </button>
  );
};

export default WishlistButton;
